import { OperationEnum, SignUpModeEnum, UserRole } from '@app/app.enum';
import * as models from '@app/models/index';
import { ISnackBarFeature } from '@app/models/shared.models';
import { InjectedIntl } from 'react-intl';
import { IUser } from '.';
import { initialUser } from './account.models';
import { IAxiosCancellation } from './core.models';

/**
 * Add user interface
 */
export interface IAddUser {
	firstName: string;
	lastName: string;
	email: string;
	role: UserRole;
	accountId?: string;
}

/**
 * Add user state
 */
export interface IAddUserProps extends IAxiosCancellation, ISnackBarFeature {
	intl: InjectedIntl;
}
export interface IAddUserState {
	showUsersList: boolean;
	currentUser: IUser;
	users: IUser[];
	operation: OperationEnum;
	loginUserId: string;
	loading: boolean;
	dataLoading: boolean;
	openConfirmationDialog: boolean;
	openInviteDialog: boolean;
	inviteId: string;
}

export const initAddUserState = (): IAddUserState => {
	return {
		showUsersList: true,
		currentUser: initialUser(),
		users: [],
		operation: OperationEnum.Add,
		loginUserId: '',
		loading: false,
		dataLoading: true,
		openConfirmationDialog: false,
		openInviteDialog: false,
		inviteId: '',
	};
};

/**
 * Initialize add user interface
 */
export const initAddUser = (): IAddUser => {
	return {
		firstName: '',
		lastName: '',
		email: '',
		role: UserRole.User,
	};
};

export interface ISignUpFormComponentState {
	showAPIKeyTextBox: boolean;
	isSignUpKeyInQueryParam: boolean;
	isTermsAccepted: boolean;
	loading: boolean;
}

export interface ISignUpFormComponentProps extends models.IAxiosCancellation {
	intl: InjectedIntl;
	signUpKey: string;
	parentAccountId: string;
	partnerAppId: string;
	quickSignUpConfiguration?: models.IQuickSignUpConfigData;
	mode: SignUpModeEnum;
	onSignUp: (user: models.IUserSignInResponse, formData?: models.ISignUpFormFields, error?: any) => void;
}



// WEBPACK FOOTER //
// ./src/models/user.models.ts